import type {
  GetFeaturesInnerParams,
  ModalProps,
} from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { getTravelExtraPackData } from '@/app/components/search/components/Card/utils/getTravelExtraPackData.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import React from 'react';
import dynamic from 'next/dynamic';

export const TravelExtraPackModal = dynamic(() => import('../../../../../Modal/Modals/TravelExtraPackModal'), {
  ssr: false,
});

export const getTravelExtraPackFeature = ({
  hasTravelExtraPack,
  product,
  localization,
  t,
  transportData,
}: GetFeaturesInnerParams): Feature[] => {
  if (!hasTravelExtraPack || !product) return [];

  const travelExtraPackData = getTravelExtraPackData({
    product,
    localization,
    t,
    transportData,
  });

  return [
    {
      icon: undefined,
      text: t('vacation.oss.cards.usp.travel_extra_pack_included'),
      className: 'travel-extra-pack',
      featureType: FeatureType.normal,
      iconRight: { category: 'Semantics', name: 'icon-circle-info', color: 'iconSecondary' } as const,
      Modal: ({ isOpen, onClose }: ModalProps) => (
        <TravelExtraPackModal isOpen={isOpen} onClose={onClose} travelExtraPackData={travelExtraPackData} />
      ),
    },
  ];
};
